import api from '../config/api';
import { Document, DocumentUpload } from '../types/document';

export const documentService = {
  uploadDocument: async (upload: DocumentUpload): Promise<Document> => {
    const formData = new FormData();
    formData.append('file', upload.file);
    formData.append('documentType', upload.documentType.toString());
    formData.append('entityType', upload.entityType.toString());
    formData.append('entityId', upload.entityId);

    const response = await api.post<Document>('/documents', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  getMyDocuments: async (): Promise<Document[]> => {
    const response = await api.get<Document[]>('/documents');
    return response.data;
  },

  getDocument: async (id: string): Promise<Document> => {
    const response = await api.get<Document>(`/documents/${id}`);
    return response.data;
  },

  downloadDocument: async (id: string): Promise<Blob> => {
    const response = await api.get(`/documents/${id}/download`, {
      responseType: 'blob',
    });
    return response.data;
  },

  deleteDocument: async (id: string): Promise<void> => {
    await api.delete(`/documents/${id}`);
  },
};
